import axios from "axios";
import {
  getCategories as _getCategories,
  getProducts as _getProducts,
  getProduct as _getProduct,
} from "../data/catalog";

// --- Catalog (no network needed; data is bundled with the build) ---
export const fetchCategories = async () => _getCategories();

export const fetchProducts = async ({ category, segment } = {}) =>
  _getProducts({ category, segment });

export const fetchProduct = async (slug) => _getProduct(slug);

// --- Enquiry form posting ---
// Dual-mode:
//   - If REACT_APP_BACKEND_URL is set (local dev with FastAPI), POST there.
//   - Else POST to relative /api/* — Vercel serverless functions handle it and
//     forward to Resend (set RESEND_API_KEY + ENQUIRY_TO_EMAIL on Vercel).
const RAW = process.env.REACT_APP_BACKEND_URL;
const API_BASE = RAW && RAW.trim() !== "" ? `${RAW}/api` : "/api";

const formClient = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export const submitEnquiry = async (payload) => {
  const { data } = await formClient.post("/enquiries", payload);
  return data;
};

export const submitCatalogRequest = async (payload) => {
  const { data } = await formClient.post("/catalog-requests", payload);
  return data;
};

// --- Admin (leads dashboard) ---
export const fetchAdminEnquiries = async (key) => {
  const { data } = await formClient.get("/enquiries", { headers: { "X-Admin-Key": key } });
  return data;
};

export const fetchAdminCatalogRequests = async (key) => {
  const { data } = await formClient.get("/catalog-requests", { headers: { "X-Admin-Key": key } });
  return data;
};

export const updateEnquiryStatus = async (key, id, status) => {
  const { data } = await formClient.patch(`/enquiries/${id}/status`, { status }, { headers: { "X-Admin-Key": key } });
  return data;
};

export const deleteEnquiry = async (key, id) => {
  const { data } = await formClient.delete(`/enquiries/${id}`, { headers: { "X-Admin-Key": key } });
  return data;
};

export const deleteCatalogRequest = async (key, id) => {
  const { data } = await formClient.delete(`/catalog-requests/${id}`, { headers: { "X-Admin-Key": key } });
  return data;
};

export const updateCatalogRequestStatus = async (key, id, status) => {
  const { data } = await formClient.patch(`/catalog-requests/${id}/status`, { status }, { headers: { "X-Admin-Key": key } });
  return data;
};

// Backward-compat exports
export const API = API_BASE;
export const api = formClient;
